export default __webpack_public_path__ + "static/media/hoa_alabama.66083677.png";